import type { JSX } from 'react';
import { Alert, Button, Text } from '@ksyos/design-system';
import { useState } from 'react';
import type { IAdminProcess } from '@common/interfaces';
import { formatString } from '@common/utils/formatString';
import { Modal } from '@frontend/components/elements/modals/Modal';
import { getSelectedLanguage } from '@frontend/translate';

type CancelModalProps = Readonly<{
    onClose: () => void;
    onConfirm: () => Promise<void>;
    process: IAdminProcess;
}>;

export function CancelModal({ onClose, onConfirm, process }: CancelModalProps): JSX.Element {
    const [isChecked, setIsChecked] = useState(false);

    return (
        <Modal
            actionButtons={[
                <Button
                    key="no"
                    onClick={onClose}
                    variant="outline"
                >
                    {getSelectedLanguage().common.no}
                </Button>,
                <Button
                    isDisabled={!isChecked}
                    key="yes"
                    onClick={onConfirm}
                >
                    {getSelectedLanguage().common.yes}
                </Button>,
            ]}
            closeOnEsc={true}
            closeOnOverlayClick={true}
            isOpen={true}
            onClose={onClose}
            size="medium"
            title={getSelectedLanguage().common.cancelForm}
        >
            <Alert
                appearance="warning"
                hasIcon={true}
            >
                {formatString(getSelectedLanguage().cancelFormDialog.removeProcess, [
                    `proces met PID ${process.processNumber}`,
                ])}
                <Alert.Checkbox
                    checked={isChecked}
                    label={
                        <Text
                            color="warning"
                            size="sm"
                        >
                            Ja, ik weet zeker dat ik dit proces wil annuleren
                        </Text>
                    }
                    onChange={(event) => setIsChecked(event.target.checked)}
                    sx={{ mt: 2 }}
                />
            </Alert>
        </Modal>
    );
}
